/** Small colored pill used to flag a job/company as newly discovered or recently closed. */
export function Tag({ kind }: { kind: "new" | "closed" }) {
  return <span className={`tag tag-${kind}`}>{kind === "new" ? "New" : "Closed"}</span>;
}
